import { FeeScheduleAction } from "./FeeScheduleAction";

export default FeeScheduleAction;
